export default __webpack_public_path__ + "images/logoAhava.57e81a4e2f3eafd84dae3e8deb7759d2.svg"